<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Does your work contribute to Africa's sustainable development?</h2>
    <p>
      Investors are increasingly using ESG measures to inform their investment strategy. Our Virtual Deal Room partners use the platform to engage with companies making a positive impact on Africa's sustainable development through projects that support the built environment, climate change and health outcomes.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Opportunities for African Businesses</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'impact-oriented',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Impact oriented Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Impact oriented Block',
      })
      this.$router.push({ path: '/about/deals' })
    },
  },
}
</script>
